import { render, staticRenderFns } from "./RolePermissionResource.vue?vue&type=template&id=55f3598a&"
import script from "./RolePermissionResource.vue?vue&type=script&lang=js&"
export * from "./RolePermissionResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports